/* SEERAT v5.4.0 — Facticied */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 750px)');

  // Columns: always open on desktop, collapsed accordions on mobile
  function syncAccordions() {
    var items = document.querySelectorAll('[data-ft-acc]');
    Array.prototype.forEach.call(items, function (d) {
      if (mq.matches) {
        d.setAttribute('open', '');
      } else if (!d.dataset.userOpened) {
        d.removeAttribute('open');
      }
    });
  }

  function bindAccordions() {
    var items = document.querySelectorAll('[data-ft-acc]');
    Array.prototype.forEach.call(items, function (d) {
      if (d.dataset.ftReady === 'true') return;
      d.dataset.ftReady = 'true';
      var summary = d.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        if (mq.matches) {
          e.preventDefault();
          return;
        }
        d.dataset.userOpened = d.hasAttribute('open') ? '' : 'true';
      });
    });
  }

  // Scale the big wordmark so it always fills the width on one line
  function fitWordmarks() {
    var marks = document.querySelectorAll('[data-ft-wordmark]');
    Array.prototype.forEach.call(marks, function (el) {
      var text = el.querySelector('span');
      if (!text) return;
      text.style.fontSize = '100px';
      var natural = text.getBoundingClientRect().width;
      var cs = window.getComputedStyle(el);
      var available = el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var share = (parseInt(el.getAttribute('data-ft-size'), 10) || 100) / 100;
      if (natural > 0 && available > 0) {
        text.style.fontSize = Math.floor((100 * available * 0.98 * share) / natural) + 'px';
      }
      el.classList.add('is-fitted');
    });
  }

  function init() {
    bindAccordions();
    syncAccordions();
    fitWordmarks();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitWordmarks);
    }
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitWordmarks, 150);
  });

  if (mq.addEventListener) {
    mq.addEventListener('change', syncAccordions);
  } else if (mq.addListener) {
    mq.addListener(syncAccordions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
